/**
 * @see https://stackoverflow.com/a/1308446/5506547
 */ function getDecimalSeparator() {
    return 1.1.toLocaleString(document.documentElement.lang).substr(1, 1);
}
const formatNumber = (number, fixed = 2)=>number.toFixed(fixed).replace(".", getDecimalSeparator());
export { getDecimalSeparator, formatNumber };
